import { Draft } from './draft'

export type SlideId = 'day' | 'kind' | 'title' | 'when' | 'details' | 'repeat' | 'calendar' | 'reminder'

// Existing items keep their type, so editing cannot discard fields.
export function visibleSlides(draft: Draft, pickDay = false, pickKind = true): SlideId[] {
    const ids: SlideId[] = pickDay ? ['day'] : []
    if (pickKind) ids.push('kind')
    ids.push('title')
    if (draft.kind === 'event') ids.push('when', 'details')
    ids.push('repeat')
    if (draft.kind === 'occasion' && draft.occasionRepeat !== 'none') ids.push('calendar')
    ids.push('reminder')
    return ids
}

export const canAdvance = (id: SlideId, draft: Draft): boolean => {
    if (id === 'title') return !!draft.title.trim()
    return true
}

export function step(id: SlideId, ids: SlideId[], delta: 1 | -1): SlideId | null {
    const index = ids.indexOf(id)
    return index < 0 ? null : ids[index + delta] || null
}

// What each step asks for, in the form the button in front of it can say. The
// wording is here rather than in the step itself because it is the step before
// that has to name it — "ادامه" alone says only that there is more, which is the
// one thing the dots already say.
const ASKS: Record<SlideId, string> = {
    day: 'انتخاب روز',
    kind: 'انتخاب نوع',
    title: 'نوشتن نام',
    when: 'مشخص کردن ساعت',
    details: 'افزودن جزئیات',
    repeat: 'تنظیم تکرار',
    calendar: 'انتخاب تقویم',
    reminder: 'تنظیم یادآوری',
}

// What the way-on button says from here: where it goes, or that this is the end
// of it. The visible steps are passed in because they change with the answers —
// an occasion has no hour to set and an event has no calendar to keep it in.
export const nextLabel = (id: SlideId, ids: SlideId[]): string => {
    const next = step(id, ids, 1)
    return next ? `ادامه و ${ASKS[next]}` : 'ذخیره'
}

// Nothing left in the flow is blocking, so what has been answered is already
// enough to write down. What lets the wizard offer a way out before the end.
export const canSave = (draft: Draft, ids: SlideId[]): boolean =>
    ids.every(id => canAdvance(id, draft))
